<i18n>
{
  "en":{
    "Label": "Create"
  },
  "fr":{
    "Label": "Créer"
  }
}
</i18n>

<template>
  <button
    :type="type"
    class="btn btn-primary"
    @click="$emit('click')">
    <IconCreate />
    <span class="d-inline-block ml-2">{{ computedLabel }}</span>
  </button>
</template>

<script>
import { computed, props } from '.';

export default {
  props,
  computed,
};
</script>
